import { alpha } from '@mui/material';

/**
 * Funções utilitárias para manipulação de temas e cores
 */

/**
 * Retorna cores para diferentes níveis de prioridade
 * @param {string} prioridade - O nível de prioridade (baixa, normal, alta, urgente)
 * @param {string} tipo - O tipo de cor (background, backgroundHover, text, border)
 * @param {Object} customTheme - O tema personalizado do Material UI
 * @returns {string} - A cor correspondente
 */
export const getPrioridadeColor = (prioridade, tipo, customTheme) => {
  const cores = {
    baixa: {
      background: alpha(customTheme.palette.info.light, 0.8),
      backgroundHover: alpha(customTheme.palette.info.main, 0.9),
      text: customTheme.palette.common.white,
      border: customTheme.palette.info.main
    },
    normal: {
      background: alpha(customTheme.palette.success.light, 0.8),
      backgroundHover: alpha(customTheme.palette.success.main, 0.9),
      text: customTheme.palette.common.white,
      border: customTheme.palette.success.main
    },
    alta: {
      background: alpha(customTheme.palette.warning.light, 0.8),
      backgroundHover: alpha(customTheme.palette.warning.main, 0.9),
      text: customTheme.palette.common.white,
      border: customTheme.palette.warning.main
    },
    urgente: {
      background: alpha(customTheme.palette.error.light, 0.8),
      backgroundHover: alpha(customTheme.palette.error.main, 0.9),
      text: customTheme.palette.common.white,
      border: customTheme.palette.error.main
    }
  };
  
  return cores[prioridade][tipo];
};

/**
 * Cria um tema personalizado para a aplicação
 * @param {Object} baseTheme - O tema base do Material UI
 * @returns {Object} - O tema personalizado
 */
export const createCustomTheme = (baseTheme) => {
  return {
    ...baseTheme,
    typography: {
      fontFamily: [
        'Montserrat',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  };
}; 